import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { User } from '../interfaces/user.type';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
const USER_AUTH_API_URL = '/api-url';

@Injectable()
export class AuthenticationService {
    private currentUserSubject: BehaviorSubject<User>;
    public currentUser: Observable<User>;

    constructor(private http: HttpClient, private cookieService: CookieService,  private router: Router) {
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }

    setCurrentUser(user: User | null): void {
        if (user) {
            localStorage.setItem('currentUser', JSON.stringify(user));
        } else {
            localStorage.removeItem('currentUser');
        }
        this.currentUserSubject.next(user);
    }

    login(username: string, password: string) {
        return this.http.post<any>(USER_AUTH_API_URL, { username, password })
        .pipe(map(user => {
            if (user && user.token) {
                this.setCurrentUser(user);
            }
            return user;
        }));
    }

    logout() {
        localStorage.removeItem('currentUser');
        // Cookies are set with path '/' on login — must delete with the same path
        this.cookieService.deleteAll('/');
        this.cookieService.deleteAll();
        this.currentUserSubject.next(null);
        this.router.navigate(['/login']);
    }
}
